import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电视剧", to: "/category/tv" },
  { label: "电影", to: "/category/movie" },
  { label: "动漫", to: "/category/anime" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap text-sm font-medium px-3 py-2 rounded-md transition-colors ${
      isActive
        ? "text-primary-700 bg-primary-100"
        : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="h-16 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
              <i className="ri-movie-2-line" />
            </span>
            <span className="text-xl font-black tracking-wide text-foreground-950">
              蜜月<span className="text-primary-600">TV</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-2">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="hidden md:flex items-center ml-auto relative">
            <i className="ri-search-line absolute left-3 text-foreground-400 text-sm" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视、资讯"
              className="w-56 lg:w-64 text-sm pl-9 pr-4 py-2 rounded-full bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <form onSubmit={handleSearch} className="relative mt-2">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视、资讯"
                className="w-full text-sm pl-9 pr-4 py-3 rounded-full bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </form>
          </div>
        </div>
      )}
    </header>
  );
}